var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoursquareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m392.773 0h-269.952c-37.088 0-48.16 28.384-48.16 46.24v433.792c0 21.376 10.752 27.68 16.64 30.144 2.304.96 6.144 1.824 10.592 1.824 6.88 0 15.232-2.048 21.984-8.832 0 0 128.224-151.008 130.304-153.472s3.104-2.464 4.512-2.464h81.088c34.656 0 41.248-24.192 45.056-38.88 3.104-12.256 38.816-187.456 49.888-242.816 8.288-42.752-2.464-65.536-41.952-65.536z",
    fill: "#ec407a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m327.461 270.752c-1.536 7.424-8.032 12.48-15.616 12.48h-53.184c-20.992 0-39.424 8.672-53.312 25.056l-66.688 78.56v-306.848c0-8.832 7.168-16 16-16h195.52c10.112 0 17.728 9.088 15.712 19.008-2.912 14.464-6.272 30.912-9.76 48.128-1.536 7.456-8.096 12.864-15.68 12.864h-89.792c-8.832 0-16 7.168-16 16v32c0 8.832 7.168 16 16 16h70.144c10.144 0 17.696 9.408 15.648 19.328-3.488 16.992-6.624 32.032-8.992 43.424z",
    fill: "#fafafa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoursquareLogo);
export default __webpack_public_path__ + "static/media/foursquare_logo.3c1ab855a721e3da551458d1f8d88135.svg";
export { ForwardRef as ReactComponent };